export enum RecipientCategories {
  ALLUSERS = "All Users",
  CURRENTWINNERS = "Current Winners",
  CURRENTOUTBIDUSERS = "Current Outbid Users",
}